module.exports = __webpack_public_path__ + "static/media/jomon_text_03.ad071541.jpg";